/**
 * @generated SignedSource<<3a7de4fd9b323da4d308cdde2b73c7e1>>
 * @relayHash 5415582d46c1093ed99dc8b056690f92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 77fe39eba17aa5cafc28b38ad0a6075f2201f7aa0c5bc9ae2ae583fd26445071

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useTrashedSpaceHardDeleteSpaceLongTaskQuery$variables = {
  id: string;
};
export type useTrashedSpaceHardDeleteSpaceLongTaskQuery$data = {
  readonly confluence: {
    readonly longTask: {
      readonly id: string;
      readonly state: {
        readonly __typename: string;
        readonly elapsedTime: AGG$Long | null | undefined;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useTrashedSpaceHardDeleteSpaceLongTaskQuery = {
  response: useTrashedSpaceHardDeleteSpaceLongTaskQuery$data;
  variables: useTrashedSpaceHardDeleteSpaceLongTaskQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "concreteType": "ConfluenceQueryApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "ConfluenceLongTask",
        "kind": "LinkedField",
        "name": "longTask",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "elapsedTime"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "__typename"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useTrashedSpaceHardDeleteSpaceLongTaskQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTrashedSpaceHardDeleteSpaceLongTaskQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5415582d46c1093ed99dc8b056690f92",
    "id": "77fe39eba17aa5cafc28b38ad0a6075f2201f7aa0c5bc9ae2ae583fd26445071",
    "metadata": {},
    "name": "useTrashedSpaceHardDeleteSpaceLongTaskQuery",
    "operationKind": "query",
    "text": "query useTrashedSpaceHardDeleteSpaceLongTaskQuery($id:ID!){confluence{longTask(id:$id){id,state{elapsedTime,name,__typename}}}}"
  }
};
})();

(node as any).hash = "d91db87dfbba3e56df610cf732a702b0";

export default node;
